import { IFormPartnerBasicInfo } from 'legacy/lut/classes/models/partner360/IFormPartnerBasicInfo'

export type TPartnerFlag = 'Power' | 'PowerElite' | 'PowerEliteGlobal'

/**
 * Power Flags are for Resellers only
 */
export const getPartnerFlags = (partnerInfo: IFormPartnerBasicInfo | undefined): TPartnerFlag[] => {
  const flags: TPartnerFlag[] = []

  if (partnerInfo?.IsPowerElite) {
    flags.push('PowerElite')
  }
  if (partnerInfo?.IsPowerEliteGlobal) {
    flags.push('PowerEliteGlobal')
  }

  if (
    !flags.length &&
    (partnerInfo?.PartnerType === 'Power' || partnerInfo?.PartnerType === 'Power CDR')
  ) {
    flags.push('Power')
  }

  return flags
}
